

import CpWorker from "../../../applications/dialogs/addvideo/graphvideo/cpworker";
import { configurations_getDefaultParams, configurations_getDefaultPlayerParams } from "../../../utils/configurations";
import VideoPlayer from "./videoplayer";

class VideoPlayerTr extends VideoPlayer
{


    constructor (props)
    {
        super(props);

        this.st =[];
        this.displayedst = -1; // sous titre affiché
        this.mode = "apply";
    
    }

    setNewSubtitles(st)
    {
      this.displayedst = -1;
      this.st = st;
      this.reDrawCurrentFrame();
      
    }
  

    getCurrentSubtitle(timecode)
    {
      
        if (!this.st) return;
        if (this.st.length == 0) return null;
  
      const nbst = this.st.length;
      timecode = this.GetLocalTimeCodeSecond(timecode);
      if (this.displayedst == -1)
      {
          for (var i=0; i < nbst; i++)
          {
            if ((timecode >= this.st[i].in ) &&
                (timecode <= this.st[i].out))
                return this.st[i];
          }
  
      }
      return null;
    }
  
    addOpacity(bg, opacity) {
        // opacity : 0 à 100
        opacity = Math.max(0, Math.min(100, opacity));

        const alpha = Math.round(opacity * 255 / 100)
            .toString(16)
            .padStart(2, "0")
            .toUpperCase();

        return bg + alpha;
    }

    drawlineSubtitle(line, context, text,timecode, displaydelay)
    {
      
      context.textBaseline = 'bottom';
      if ( (this.props.stparams) && (this.props.stparams.teletext))
      {
        context.font = "bold 32px Courier";
        text = " " + text;
      }
      else
        context.font = "36px Arial"
  
  
   
  
      const marge = 40;
      const hauteurligne = (576 - 2 * marge)  / 22;
      const y = marge +  hauteurligne * line.verticalPos;
  
  
      var x = marge;

      var m = null;
      var width = 0;
      if (!this.props.stparams.teletext)
      {
        m = context.measureText(text);
        width = m.width;
      }
      else
      {
          context.save();
          context.scale(0.8, 1); // 80% de la largeur
          m = context.measureText(text);
          width = m.width * 0.8;
          context.restore();      

      }
      var tw = width;
      var th = m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
      switch (line.align)
      {
        case 1:
          x = 720 - marge - tw;
          break;
        case 2:
          x = 720 / 2 - tw / 2;
          break;
      }
  
      
      var ta
      


      if (!this.props.stparams.teletext)
      {
        if (!this.props.params.background)
          context.strokeText(text,x,y);
        else
        {
          context.fillStyle= this.addOpacity("#000000", this.props.params.backgroundtransparency);
          context.fillRect(x,y - th - 17,tw,hauteurligne * 2);
        }
        context.fillStyle = line.words[0].color;
        context.fillText (text,x,y );
      }
      else
      {
          context.save();
          context.fillStyle= this.addOpacity("#000000", this.props.params.backgroundtransparency);
          context.scale(0.8, 1); // 80% de la largeur
          context.fillRect(x / 0.8,y - th - 17,tw / 0.8,hauteurligne * 2);
          
          context.fillStyle = line.words[0].color;
          context.fillText(text, x / 0.8, y);
          

          context.restore();      
      }
  
      
  
      if (displaydelay)
      {
        context.font = "18px bold Arial";
        const arrondi = Math.round((timecode) * 10) / 10;
  
  
        var delay = arrondi.toString();
        if (arrondi>=0) delay = "+" + delay;
  
        const m = context.measureText(delay);
        var tw0 = m.width;
        var th0 = m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
  
        context.fillStyle = "black";
        context.fillRect(x-3,y - th - 14 - th0, 6+tw0, th0+6);
  
        context.fillStyle = "white";
        context.fillText (delay,x,y - th - 8);
      }
  
    }
  




drawSubtitle = (timecode) =>
    {

      const cst = this.getCurrentSubtitle(timecode);



      const canvas = this.canvasLevel3Ref.current;
      const contextfinal = canvas.getContext('2d');

      var tempCanvas = document.createElement("canvas")
      const context = tempCanvas.getContext('2d');
      
      //;
      //context.fillStyle="white";


      
      var devicePixelRatio = window.devicePixelRatio || 1;
      var backingStoreRatio = context.webkitBackingStorePixelRatio ||
                          context.mozBackingStorePixelRatio ||
                          context.msBackingStorePixelRatio ||
                          context.oBackingStorePixelRatio ||
                          context.backingStorePixelRatio || 1;
  
      var ratio = devicePixelRatio / backingStoreRatio;
  
    // upscale the canvas if the two ratios don't match


      canvas.width = 720; canvas.height = 576;
      tempCanvas.width = 720 ; tempCanvas.height = 576 ;


      if (cst==null) return;

      var lig1=""; 
      if (cst.lines.length > 0)
        for (var i=0; i< cst.lines[0].words.length; i++)
            lig1 = lig1 + cst.lines[0].words[i].text + " ";
  
      var lig2=""; 
      if (cst.lines.length > 1)
      for (var i=0; i< cst.lines[1].words.length; i++)
          lig2 = lig2 + cst.lines[1].words[i].text + " ";
  

      

      
      context.strokeStyle = "black";
      context.lineWidth = 6;

      if (lig1 !="")
        this.drawlineSubtitle(cst.lines[0], context, lig1, cst.in - cst.lines[0].words[0].in ,true);
      if (lig2 !="")
        this.drawlineSubtitle(cst.lines[1], context, lig2,cst.in - cst.lines[1].words[0].in ,(lig1==""));


      

      // calcul du decalage y

      const hauteurcvideo = this.state.videoheighty + 2 * this.state.videostarty;
      const largeurcvideo = this.state.videowidthx + 2 * this.state.videostartx;

      const decaley = (this.state.videostarty / hauteurcvideo) * canvas.height;
      const decalex = (this.state.videostartx / largeurcvideo) * canvas.width;



      contextfinal.drawImage(tempCanvas,0,0,tempCanvas.width,tempCanvas.height, decalex, decaley ,canvas.width - 2 * decalex, canvas.height - 2 * decaley);

    }



    // *******************************************
    // functions pures
    // *******************************************
    childDrawVideoToCanvas(timecode)
    {
        this.drawSubtitle(timecode);
    }
    childRedrawCurrentFrame(timecode)
    {

        this.drawSubtitle(timecode);

    }
}


VideoPlayerTr.defaultProps =
{
    stparams: configurations_getDefaultParams(),
    params: configurations_getDefaultPlayerParams()
};

export default VideoPlayerTr